import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { IconsModule } from '@core/icons/icons.module';
import { TranslocoCoreModule } from '@core/transloco/transloco.module';
import { TxDragDropUploadComponent } from './tx-drag-drop-upload.component';
import { TxDragDropUploadDirective } from './tx-drag-drop-upload.directive';

@NgModule({
  declarations: [TxDragDropUploadDirective, TxDragDropUploadComponent],
  imports: [
    CommonModule,
    TranslocoCoreModule,
    MatIconModule,
    IconsModule,
    MatButtonModule,
  ],
  exports: [TxDragDropUploadDirective, TxDragDropUploadComponent],
})
export class TxDragDropUploadModule {}
